import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassReport extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassReport'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: null,
      visibility: 'private',
      expiresAt: null,
      data: null,
      title: null,
      isActive: true,
    }
  }
}
const servicePath = 'compass-reports'
const servicePlugin = makeServicePlugin({
  Model: CompassReport,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
